module.exports = __webpack_public_path__ + "static/img/7.3cb358e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/2/sp/7.png
// module id = Y3Tp
// module chunks = 0